import { useState } from "react";
import { fmt } from "./Utils/Utilities";
import { Badge } from "./SharedUI";

// ─── Mock Data ────────────────────────────────────────────────────────────────
const MOCK_ORDER_HISTORY = [
  {
    id: "ORD-8821", customerId: "ACC-0042",
    total: 84000,
    region: "Gauteng", depot: "Johannesburg North",
    driver: "Sipho Mahlangu", vehicle: "GP 44-21 BT",
    orderDate: "2025-04-22", dispatchDate: "2025-04-23", deliveryDate: "2025-04-23",
    invoiceId: "INV-8821", status: "Delivered",
    products: [
      { name: "LPG ", qty: 50, unit: "cylinders" },
      { name: "Oxygen 13kg", qty: 100, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-22 08:00", done: true },
      { label: "Confirmed",      time: "2025-04-22 08:45", done: true },
      { label: "Allocated",      time: "2025-04-22 09:00", done: true },
      { label: "Dispatched",     time: "2025-04-23 07:30", done: true },
      { label: "Delivered",      time: "2025-04-23 10:30", done: true },
    ],
  },
  {
    id: "ORD-8822", customerId: "ACC-0011",
    total: 192000,
    region: "Gauteng", depot: "Centurion",
    driver: "Bongani Dube", vehicle: "GP 12-80 AX",
    orderDate: "2025-04-22", dispatchDate: "2025-04-22", deliveryDate: "2025-04-22",
    invoiceId: "INV-8822", status: "Delivered",
    products: [
      { name: "LPG Cylinder 13kg", qty: 40, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-22 06:00", done: true },
      { label: "Confirmed",      time: "2025-04-22 06:10", done: true },
      { label: "Allocated",      time: "2025-04-22 06:15", done: true },
      { label: "Dispatched",     time: "2025-04-22 08:00", done: true },
      { label: "Delivered",      time: "2025-04-22 14:00", done: true },
    ],
  },
  {
    id: "ORD-8830", customerId: "ACC-0031",
    total: 36800,
    region: "Vaal Triangle", depot: "Vereeniging",
    driver: "Themba Sithole", vehicle: "GP 88-14 CZ",
    orderDate: "2025-04-24", dispatchDate: null, deliveryDate: null,
    invoiceId: "INV-8823", status: "Pending",
    products: [
      { name: "Natural Gas", qty: 15, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-24 07:00", done: true },
      { label: "Confirmed",      time: "2025-04-24 07:30", done: true },
      { label: "Allocated",      time: "2025-04-24 07:45", done: true },
      { label: "Dispatched",     time: null,               done: false },
      { label: "Delivered",      time: null,               done: false },
    ],
  },
  {
    id: "ORD-8831", customerId: "ACC-0061",
    total: 28400,
    region: "Gauteng", depot: "Johannesburg North",
    driver: "Mandla Khumalo", vehicle: "GP 33-09 DX",
    orderDate: "2025-04-24", dispatchDate: "2025-04-25", deliveryDate: null,
    invoiceId: "INV-8824", status: "In Transit",
    products: [
      { name: "CNG", qty: 8, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-24 08:00", done: true },
      { label: "Confirmed",      time: "2025-04-24 08:20", done: true },
      { label: "Allocated",      time: "2025-04-24 08:30", done: true },
      { label: "Dispatched",     time: "2025-04-25 07:00", done: true },
      { label: "Delivered",      time: null,               done: false },
    ],
  },
  {
    id: "ORD-8835", customerId: "ACC-0072",
    total: 47500,
    region: "Gauteng", depot: "Centurion",
    driver: "Sipho Mahlangu", vehicle: "GP 44-21 BT",
    orderDate: "2025-04-25", dispatchDate: "2025-04-26", deliveryDate: null,
    invoiceId: "INV-8825", status: "In Transit",
    products: [
      { name: "LPG ", qty: 35, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-25 06:00", done: true },
      { label: "Confirmed",      time: "2025-04-25 06:30", done: true },
      { label: "Allocated",      time: "2025-04-25 06:45", done: true },
      { label: "Dispatched",     time: "2025-04-26 06:00", done: true },
      { label: "Delivered",      time: null,               done: false },
    ],
  },
  {
    id: "ORD-8840", customerId: "ACC-0018",
    total: 112000,
    region: "Vaal Triangle", depot: "Vereeniging",
    driver: null, vehicle: null,
    orderDate: "2025-04-26", dispatchDate: null, deliveryDate: null,
    invoiceId: "INV-8826", status: "Cancelled",
    products: [
      { name: "oxygen", qty: 25, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-26 07:00", done: true },
      { label: "Confirmed",      time: "2025-04-26 07:15", done: true },
      { label: "Allocated",      time: "2025-04-26 07:20", done: true },
      { label: "Dispatched",     time: null,               done: false },
      { label: "Delivered",      time: null,               done: false },
    ],
  },
  {
    id: "ORD-8841", customerId: "ACC-0084",
    total: 9750,
    region: "Gauteng", depot: "Johannesburg South",
    driver: "Bongani Dube", vehicle: "GP 12-80 AX",
    orderDate: "2025-04-26", dispatchDate: "2025-04-27", deliveryDate: "2025-04-27",
    invoiceId: "INV-8827", status: "Delivered",
    products: [
      { name: "LPG Cylinder 13kg", qty: 75, unit: "cylinders" },
    ],
    timeline: [
      { label: "Order Placed",   time: "2025-04-26 09:00", done: true },
      { label: "Confirmed",      time: "2025-04-26 09:20", done: true },
      { label: "Allocated",      time: "2025-04-26 10:00", done: true },
      { label: "Dispatched",     time: "2025-04-27 07:30", done: true },
      { label: "Delivered",      time: "2025-04-27 09:45", done: true },
    ],
  },
];

const STATUS_META = {
  Delivered:   { color: "var(--success)", bg: "rgba(0,230,118,.1)",  border: "rgba(0,230,118,.25)" },
  Pending:     { color: "var(--amber)",   bg: "rgba(255,171,0,.1)",  border: "rgba(255,171,0,.25)" },
  Confirmed:   { color: "var(--teal)",    bg: "rgba(29,233,182,.1)", border: "rgba(29,233,182,.25)"},
  Processing:  { color: "var(--blue)",    bg: "rgba(64,196,255,.1)", border: "rgba(64,196,255,.25)"},
  Cancelled:   { color: "var(--danger)",  bg: "rgba(255,23,68,.1)",  border: "rgba(255,23,68,.25)" },
  "In Transit":{ color: "var(--blue)",    bg: "rgba(64,196,255,.1)", border: "rgba(64,196,255,.25)"},
};

// Statuses shown in the summary pill row — exclude Delivered & In Transit (shown in KPIs above)
const PILL_STATUSES = ["Pending", "Cancelled"];

function StatusPill({ status }) {
  const s = STATUS_META[status] || STATUS_META["Pending"];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "2px 9px", borderRadius: 20, fontSize: 10, fontWeight: 700, color: s.color, background: s.bg, border: `1px solid ${s.border}` }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: s.color, display: "inline-block" }} />
      {status}
    </span>
  );
}

// ─── Order KPIs ───────────────────────────────────────────────────────────────
function OrderKPIs({ orders }) {
  const total      = orders.length;
  const delivered  = orders.filter((o) => o.status === "Delivered").length;
  const inTransit  = orders.filter((o) => o.status === "In Transit").length;
  const expense    = orders.reduce((s, o) => s + o.total, 0);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 16 }}>
      {[
        { label: "Total Orders",  value: total,                accent: "linear-gradient(90deg,var(--blue),var(--teal))",    sub: "in selected period",                              cls: "" },
        { label: "Total Expense", value: fmt.currency(expense), accent: "linear-gradient(90deg,var(--flame),var(--amber))", sub: "across all orders",                               cls: "" },
        { label: "Delivered",     value: delivered,             accent: "linear-gradient(90deg,var(--success),var(--teal))", sub: `${Math.round((delivered/total)*100)}% delivery rate`, cls: "t-success" },
        { label: "In Transit",    value: inTransit,             accent: "linear-gradient(90deg,var(--blue),var(--teal))",    sub: "currently on the road",                           cls: "t-blue" },
      ].map(({ label, value, accent, sub, cls }) => (
        <div key={label} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 16, position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: accent }} />
          <div className="fs10 tc3" style={{ marginBottom: 8, textTransform: "uppercase", letterSpacing: ".1em", fontWeight: 700 }}>{label}</div>
          <div className={`syne fw7 fs22 ${cls}`}>{value}</div>
          {sub && <div className="fs10 tc3" style={{ marginTop: 4 }}>{sub}</div>}
        </div>
      ))}
    </div>
  );
}

// ─── Order Detail Drawer ──────────────────────────────────────────────────────
function OrderDrawer({ order, onClose, showToast: toast }) {
  if (!order) return null;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 900, display: "flex" }} onClick={onClose}>
      <div style={{ flex: 1, background: "rgba(0,0,0,.55)", backdropFilter: "blur(4px)" }} />
      <div
        style={{ width: 440, background: "var(--surface)", borderLeft: "1px solid var(--border)", display: "flex", flexDirection: "column", overflowY: "auto", animation: "slideInRight .2s ease" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "18px 22px", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ flex: 1 }}>
            <div className="syne fw7 fs14">{order.id}</div>
          </div>
          <StatusPill status={order.status} />
          <button className="btn btn-g btn-sm btn-ico" onClick={onClose}>
            <i className="bi bi-x" style={{ fontSize: 14 }} />
          </button>
        </div>

        <div style={{ padding: "18px 22px", flex: 1 }}>
          <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 14 }}>Delivery Timeline</div>
          <div style={{ marginBottom: 22 }}>
            {order.timeline.map((step, i) => (
              <div key={step.label} style={{ display: "flex", gap: 12, paddingBottom: 14, position: "relative" }}>
                {i < order.timeline.length - 1 && (
                  <div style={{ position: "absolute", left: 11, top: 24, bottom: 0, width: 2, background: step.done ? "var(--teal)" : "var(--border)", opacity: .5 }} />
                )}
                <div style={{ width: 24, height: 24, borderRadius: "50%", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, background: step.done ? "rgba(29,233,182,.15)" : "var(--elevated)", border: `2px solid ${step.done ? "var(--teal)" : "var(--border)"}`, color: step.done ? "var(--teal)" : "var(--text3)" }}>
                  {step.done ? <i className="bi bi-check" /> : <i className="bi bi-circle" />}
                </div>
                <div>
                  <div className="fs12 fw6" style={{ color: step.done ? "var(--text1)" : "var(--text3)" }}>{step.label}</div>
                  <div className="fs10 tc3">{step.time || "—"}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 12 }}>Order Details</div>
          {[
            ["Order Value", fmt.currency(order.total)],
            ["Depot",       order.depot],
            ["Region",      order.region],
            ["Order Date",  order.orderDate],
            ["Dispatch",    order.dispatchDate || "—"],
            ["Delivered",   order.deliveryDate || "—"],
            ["Invoice",     order.invoiceId || "Not yet issued"],
          ].map(([k, v]) => (
            <div key={k} className="fb" style={{ paddingBottom: 9, marginBottom: 9, borderBottom: "1px solid var(--border)" }}>
              <span className="fs11 tc3">{k}</span>
              <span className="fs11 fw6">{v}</span>
            </div>
          ))}

          {order.products && (
            <>
              <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", marginTop: 8, marginBottom: 8 }}>Products</div>
              <div style={{ marginBottom: 12 }}>
                {order.products.map((p) => (
                  <div key={p.name} className="fb" style={{ paddingBottom: 6 }}>
                    <span className="fs11 tc3">{p.name}</span>
                    <span className="fs11 fw6">{p.qty} {p.unit || ""}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          {order.driver && (
            <>
              <div className="fs11 fw7 tc3" style={{ textTransform: "uppercase", letterSpacing: ".1em", margin: "16px 0 12px" }}>Driver & Vehicle</div>
              <div style={{ background: "var(--elevated)", border: "1px solid var(--border)", borderRadius: 10, padding: "12px 14px", display: "flex", gap: 12, alignItems: "center" }}>
                <div style={{ width: 36, height: 36, borderRadius: "50%", background: "linear-gradient(135deg,var(--blue),var(--teal))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: "var(--deep)" }}>
                  {order.driver.split(" ").map((n) => n[0]).join("")}
                </div>
                <div>
                  <div className="fs12 fw6">{order.driver}</div>
                  <div className="fs10 tc3">{order.vehicle}</div>
                </div>
              </div>
            </>
          )}
        </div>

        <div style={{ padding: "14px 22px", borderTop: "1px solid var(--border)", display: "flex", gap: 8 }}>
          <button className="btn btn-s btn-sm" style={{ flex: 1 }} onClick={() => toast(`${order.id} printed`, "s")}>
            <i className="bi bi-printer" /> Print
          </button>
          {order.invoiceId && (
            <button className="btn btn-p btn-sm" style={{ flex: 1 }} onClick={() => toast(`${order.invoiceId} opened`, "s")}>
              <i className="bi bi-receipt" /> View Invoice
            </button>
          )}
        </div>
      </div>

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
      `}</style>
    </div>
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
function OrderHistoryPage({ showToast: toast, onBack }) {
  const [search,        setSearch]        = useState("");
  const [filterStatus,  setFilterStatus]  = useState("all");
  const [filterRegion,  setFilterRegion]  = useState("all");
  const [filterProd,    setFilterProd]    = useState("all");
  const [selectedOrder, setSelectedOrder] = useState(null);

  const regions  = [...new Set(MOCK_ORDER_HISTORY.map((o) => o.region))];
  const products = [...new Set(MOCK_ORDER_HISTORY.map((o) => o.product))];
  const statuses = [...new Set(MOCK_ORDER_HISTORY.map((o) => o.status))];

  const filtered = MOCK_ORDER_HISTORY.filter((o) => {
    if (filterStatus !== "all" && o.status !== filterStatus) return false;
    if (filterRegion !== "all" && o.region !== filterRegion) return false;
    if (filterProd   !== "all" && o.product !== filterProd)  return false;
    if (search) {
      const q = search.toLowerCase();
      return o.id.toLowerCase().includes(q) || (o.invoiceId || "").toLowerCase().includes(q);
    }
    return true;
  });

  return (
    <div className="page">
      {/* breadcrumb */}
      <div className="fc gap8 mb16">
        <button className="btn btn-g btn-sm" onClick={onBack} style={{ gap: 5 }}>
          <i className="bi bi-arrow-left" style={{ fontSize: 11 }} /> Reporting
        </button>
        <span className="tc3 fs11">/</span>
        <span className="fs11 tc2">Order History</span>
      </div>

      {/* hero */}
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, padding: "18px 22px", marginBottom: 16, display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ flex: 1 }}>
          <div className="syne fw7" style={{ fontSize: 17 }}>Order History</div>
          <div className="fs11 tc3" style={{ marginTop: 3 }}>Full order log with delivery timeline, driver details, and invoice linkage — click any row to expand</div>
        </div>
      </div>

      <OrderKPIs orders={MOCK_ORDER_HISTORY} />

      {/* status summary pills — Pending & Cancelled only (Delivered & In Transit shown in KPIs above) */}
      <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
        {PILL_STATUSES.map((s) => {
          const meta  = STATUS_META[s] || STATUS_META["Pending"];
          const count = MOCK_ORDER_HISTORY.filter((o) => o.status === s).length;
          const rev   = MOCK_ORDER_HISTORY.filter((o) => o.status === s).reduce((sum, o) => sum + o.total, 0);
          return (
            <div
              key={s}
              onClick={() => setFilterStatus(filterStatus === s ? "all" : s)}
              style={{ background: "var(--surface)", border: `1px solid ${filterStatus === s ? meta.color : "var(--border)"}`, borderTop: `2px solid ${meta.color}`, borderRadius: 10, padding: "10px 14px", cursor: "pointer", transition: "all .14s", minWidth: 130 }}
            >
              <div style={{ fontSize: 9, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: meta.color, marginBottom: 6 }}>{s}</div>
              <div className="syne fw7 fs18">{count}</div>
              <div className="mono fs10 tc3" style={{ marginTop: 2 }}>{fmt.currency(rev)}</div>
            </div>
          );
        })}
      </div>

      {/* table panel */}
      <div className="panel">
        <div className="tbar">
          <div className="tsearch">
            <i className="bi bi-search" style={{ color: "var(--text3)", fontSize: 12 }} />
            <input placeholder="Search order, customer, product…" value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <select className="tfilter" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
            <option value="all">All Statuses</option>
            {statuses.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
          <select className="tfilter" value={filterRegion} onChange={(e) => setFilterRegion(e.target.value)}>
            <option value="all">All Regions</option>
            {regions.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
          <select className="tfilter" value={filterProd} onChange={(e) => setFilterProd(e.target.value)}>
            <option value="all">All Products</option>
            {products.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
          <span className="fs11 tc3" style={{ marginLeft: "auto" }}>{filtered.length} orders</span>
        </div>

        <table className="tbl">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Invoice ID</th>
              <th>Value</th>
              <th>Region</th>
              <th>Driver</th>
              <th>Order Date</th>
              <th>Delivered</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((o) => (
              <tr key={o.id} style={{ cursor: "pointer" }} onClick={() => setSelectedOrder(o)}>
                <td className="mono t-flame" style={{ fontSize: 11 }}>{o.id}</td>
                <td className="fs12 fw6" style={{ maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{o.invoiceId || <span className="tc3">—</span>}</td>
                <td className="mono fw7 fs12">{fmt.currency(o.total)}</td>
                <td><span className="tag">{o.region}</span></td>
                <td className="fs11 tc2">{o.driver || <span className="tc3">—</span>}</td>
                <td className="mono fs10 tc3">{o.orderDate}</td>
                <td className="mono fs10 tc3">{o.deliveryDate || <span className="tc3">—</span>}</td>
                <td><StatusPill status={o.status} /></td>
                <td>
                  <i className="bi bi-chevron-right" style={{ fontSize: 10, color: "var(--text3)" }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filtered.length === 0 && (
          <div className="empty"><div>No orders match your filters</div></div>
        )}

        <div style={{ padding: "12px 18px", borderTop: "1px solid var(--border)", display: "flex", gap: 24 }}>
          <span className="fs11 tc3">Showing {filtered.length} of {MOCK_ORDER_HISTORY.length}</span>
          <span className="fs11 tc3">|</span>
          <span className="fs11 tc2">Total value: <span className="mono fw7">{fmt.currency(filtered.reduce((s, o) => s + o.total, 0))}</span></span>
        </div>
      </div>

      {selectedOrder && (
        <OrderDrawer
          order={selectedOrder}
          onClose={() => setSelectedOrder(null)}
          showToast={toast}
        />
      )}
    </div>
  );
}

export default OrderHistoryPage;
export { MOCK_ORDER_HISTORY };